import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig} from "config/config"; // Importing development configuration

/**
 * Class representing the view for managing sub-providers.
 * @extends JetView
 */
export default class tableSubProvidersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [{
                id: "preloader", // ID for the preloader
                cols: [
                    {
                        view: "datatable", id: "datatable", // DataTable view for displaying sub-providers
                        css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                        select: true, // Enable row selection
                        scrollY: true, // Enable vertical scrolling
                        columns: [
                            {
                                id: "rating", header: "", width: 50, height: 25, // Column for rating
                                template: function (obj) {
                                    // Template for edit icon based on permissions
                                    if (devConfig.getPermAction("ProvidersEdit", "Edit")) {
                                        return "<span class='webix_icon wxi-close edit'></span>";
                                    } else {
                                        return "";
                                    }
                                }
                            },
                            {id: "Id", header: _("SubProveedor Id"), width: 100, sort: "int"}, // Column for SubProvider ID
                            {id: "ProviderId", header: _("Proveedor Id"), width: 100, sort: "int"}, // Column for Provider ID
                            {id: "Name", header: _("Nombre"), width: 150, sort: "int"}, // Column for Name
                            {id: "Type", header: _("Tipo"), width: 150, sort: "int"}, // Column for Type
                            {
                                id: "IsActivate", header: _("Estado"), editor: "combo", options: [
                                    {"id": "A", "value": _("Activado")}, // Active option
                                    {"id": "I", "value": _("Inactivado")} // Inactive option
                                ], width: 100, sort: "int"
                            },
                            {
                                id: "IsVerified", header: _("Verificado"), editor: "combo", options: [
                                    {"id": "A", "value": _("Activado")}, // Verified option
                                    {"id": "I", "value": _("Inactivado")} // Not verified option
                                ], width: 100, sort: "int"
                            },
                            {id: "Abbreviated", header: _("Abreviado"), width: 100, sort: "int"}, // Column for Abbreviated name
                            {id: "Image", header: _("Imagen"), width: 570, sort: "int"}, // Column for Image
                        ],
                        onClick: {
                            "edit": function (euv, id) {
                                var item = this.getItem(id); // Get the clicked item
                                $$("editwinProviders").show(); // Show edit window
                                // Prepare credentials for display
                                if(item.Credentials != undefined && item.Credentials != null && item.Credentials != ''){
                                    item.Credentials = JSON.stringify(item.Credentials, null, 2);
                                }else{
                                    item.Credentials = '';
                                }
                            }
                        },
                        math: true, // Enable math operations
                        loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                        pager: "pagerA" // Pager ID for pagination
                    }
                ]
            }]
        };
    }

    /**
     * Initializes the view and binds events.
     * @param {Object} grid - The grid instance to initialize.
     */
    init(grid) {
        const _ = this.app.getService("locale")._; // Localization service
        grid = $$('datatable'); // Reference to the data table
        var url = devConfig.geturlApi() + "Providers/GetSubProviders"; // API URL for fetching sub-providers
        var filter = ""; // Filter string for data loading
        var popup = webix.ui({
            view: "window", // Popup window for editing sub-provider
            id: "editwinProviders",
            width: (screen.width < 500) ? 350 : 500, // Width based on screen size
            height: 450,
            fullscreen: (screen.width < 500) ? true : false, // Fullscreen mode for small screens
            head: {
                view: "toolbar",
                cols: [
                    {view: "label", label: _("Editar Subproveedor")}, // Label for editing sub-provider
                    {
                        view: "icon", icon: "wxi-close", click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        }
                    }
                ]
            },
            position: "center", // Center the popup
            modal: false, // Non-modal window
            body: {
                view: "scrollview", // Scrollable body
                scroll: "y",
                body: {
                    view: "form", id: "editform", // Form for editing sub-provider details
                    width: (screen.width < 500) ? 350 : 450,
                    height: (screen.width < 500) ? 650 : 470,
                    elements: [
                        {
                            view: "text",
                            label: "Id",
                            name: "Id",
                            readonly: true, // Read-only field for ID
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "text",
                            label: _("Nombre"),
                            name: "Name",
                            readonly: true, // Read-only field for Name
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "text",
                            label: _("Tipo"),
                            name: "Type",
                            readonly: true, // Read-only field for Type
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "combo",
                            label: _("Estado"),
                            name: "IsActivate",
                            options: [
                                {"id": "A", "value": _("Activado")}, // Active option
                                {"id": "I", "value": _("Inactivado")} // Inactive option
                            ],
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "combo",
                            label: _("Verificado"),
                            name: "IsVerified",
                            options: [
                                {"id": "A", "value": _("Activado")}, // Verified option
                                {"id": "I", "value": _("Inactivado")} // Not verified option
                            ],
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "text",
                            label: _("Abreviado"),
                            name: "Abbreviated",
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "text",
                            label: _("Imagen"),
                            name: "Image",
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "textarea",
                            label: _("Credenciales"),
                            name: "Credentials",
                            required: false,
                            disabled: true, // Disabled field for Credentials
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150,
                            height: 80,
                            scroll: "auto"
                        },
                        {
                            cols: [
                                {
                                    view: "button", value: _("Cancelar"), click: function () {
                                        this.getTopParentView().hide(); // Close the popup
                                    }
                                },
                                {
                                    view: "button", type: "form", value: _("Guardar"), click: function ($e) {
                                        var values = $$("editform").getValues(); // Get form values
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "Provider/UpdateSubproviderDetails", '{"Id":' + values.Id + ',"IsActivate":"' + values.IsActivate + '","IsVerified":"' + values.IsVerified + '","Name":"' + values.Name + '","Abbreviated":"' + values.Abbreviated + '","Image":"' + values.Image + '"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message("Error! "); // Show error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                webix.message("Cell value was changed"); // Show success message
                                                grid.clearAll(); // Clear grid data
                                                grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter); // Reload grid data
                                            }
                                        });
                                        $$('editform').setValues($$('editform').getCleanValues()); // Reset form values
                                        this.getTopParentView().hide(); // Close the popup
                                    }
                                }
                            ]
                        }
                    ]
                }
            }
        });
        var popupAdd = webix.ui({
            view: "window", // Popup window for adding sub-provider
            id: "AddProviders",
            width: (screen.width < 500) ? 350 : 450,
            height: (screen.width < 500) ? 650 : 530,
            fullscreen: (screen.width < 500) ? true : false, // Fullscreen mode for small screens
            head: {
                view: "toolbar",
                cols: [
                    {view: "label", label: _("Añadir Subproveedor")}, // Label for adding sub-provider
                    {
                        view: "icon", icon: "wxi-close", click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        }
                    }
                ]
            },
            position: "center", // Center the popup
            modal: true, // Modal window
            body: {
                view: "scrollview", scroll: "y",
                body: {
                    view: "form", id: "addform", // Form for adding sub-provider details
                    width: (screen.width < 500) ? 350 : 450,
                    height: (screen.width < 500) ? 650 : 470,
                    elements: [
                        {
                            view: "text",
                            label: _("Nombre"),
                            name: "Name",
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "combo", name: "ProviderId", minWidth: 200, labelWidth: 150,
                            label: _("Proveedor"), labelPosition: (screen.width < 500) ? "top" : "left",
                            placeholder: _("Click para seleccionar "), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) { // Fetch providers based on input
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "es/Select/ProvidersCasinoSelect", '{"Filter":"' + text + '"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message("Error! "); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parse response
                                                    if (!resp.HasError) {
                                                        vthis.clearAll(); // Clear previous options
                                                        vthis.parse(resp.Data); // Populate options with new data
                                                    }
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                        },
                        {
                            view: "combo", label: _("Tipo"), name: "Type", options: [
                                {"id": "1", "value": "CASINO"},
                                {"id": "2", "value": "LIVECASINO"},
                                {"id": "3", "value": "PAYMENT"},
                                {"id": "4", "value": "PAYOUT"},
                                {"id": "5", "value": "SPORTS"},
                                {"id": "6", "value": "VERIFICATION"},
                                {"id": "7", "value": "VERIFY"},
                                {"id": "8", "value": "VIRTUAL"},
                                {"id": "9", "value": "WHATSAPP"},
                                {"id": "10", "value": "MENSAJERIA"}
                            ], labelPosition: (screen.width < 500) ? "top" : "left", labelWidth: 150
                        },
                        {
                            view: "combo",
                            label: _("Estado"),
                            name: "IsActivate",
                            options: [
                                {"id": "A", "value": _("Activado")}, // Active option
                                {"id": "I", "value": _("Inactivado")} // Inactive option
                            ],
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "combo",
                            label: _("Verificado"),
                            name: "IsVerified",
                            options: [
                                {"id": "A", "value": _("Activado")}, // Verified option
                                {"id": "I", "value": _("Inactivado")} // Not verified option
                            ],
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "text",
                            label: _("Abreviado"),
                            name: "Abbreviated",
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        {
                            view: "text",
                            label: _("Imagen"),
                            name: "Image",
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150
                        },
                        { gravity: 0.01 }, // Spacer
                        {
                            view: "textarea",
                            label: _("Credenciales"),
                            name: "Credentials",
                            required: false,
                            disabled: false, // Enabled field for Credentials
                            labelPosition: (screen.width < 500) ? "top" : "left",
                            labelWidth: 150,
                            height: 80,
                            scroll: "auto"
                        },
                        {
                            cols: [
                                {
                                    view: "button", value: _("Cancelar"), click: function () {
                                        this.getTopParentView().hide(); // Close the popup
                                        console.log('cancela'); // Log cancellation
                                    }
                                },
                                {
                                    view: "button", type: "form", value: _("Guardar"), click: function ($e) {
                                        var values = $$("addform").getValues(); // Get form values
                                        if ($$("addform").validate()){ // Validate form
                                            var credentialsBase64 = btoa(values.Credentials); // Encode credentials
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Provider/UpdateSubproviderDetails",
                                                '{"Type":"' + values.Type + '","ProviderId":"' + values.ProviderId + '", "IsActivate":"' + values.IsActivate + '","IsVerified":"' + values.IsVerified + '","Name":"' + values.Name + '","Abbreviated":"' + values.Abbreviated + '","Credentials":' + JSON.stringify(credentialsBase64) + ',"Image":"' + values.Image + '"}', {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message("Error! "); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message("Cell value was changed"); // Show success message
                                                        grid.clearAll(); // Clear grid data
                                                        grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter); // Reload grid data
                                                    }
                                                });
                                            $$('addform').setValues($$('addform').getCleanValues()); // Reset form values
                                            this.getTopParentView().hide(); // Close the popup
                                        }else{
                                            webix.message({
                                                title: _("¡Error!"),
                                                type: "alert-error",
                                                text: _("Completa los campos...") // Show validation error message
                                            });
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                }
            }
        });
        this.on(this.app, "addProvider:button", filter => {
            popupAdd.show(); // Show add provider popup
        });
        this.on(this.app, "providers:filter", filterData => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = "";
            for (var i = 0; i < object.length; i++) {
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) {
                    if (object[i][0] == "Datepicker") {
                        var date = object[i][1].split(" - "); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if ((typeof object[i][1] === "object")) {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") {
                                    var d = new Date(object2[j][1]); // Convert start date to Date object
                                    var dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === "end") {
                                        var d = new Date(object2[j][1]); // Convert end date to Date object
                                        var dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter
        });
        grid.attachEvent("onAfterSort", function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Reload data after sorting
        });
        grid.attachEvent("onItemClick", function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent("user:id", [item.Id]); // Trigger user ID event
        });
        grid.attachEvent("onItemDblClick", function (id, e, node) {
            var item = this.getItem(id); // Get double-clicked item
            popup.show(); // Show edit popup
        });
        this.on(this.app, "player:select", Id => {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data based on selected player
        });
        $$("editform").bind($$("datatable")); // Bind edit form to data table
    }
}

// FILE DOCUMENTED
